import get from 'lodash/get'
import { R } from '@utils/currency'
import { convertAssetCurrencyToZar } from '@utils/currency/conversions'

export const assetToggleNameAttributeMap = {
  lifeCover: 'selected_for_life_cover_assessment',
  disabilityCover: 'selected_for_disability_cover_assessment',
  incomeProtection: 'selected_for_income_protection_assessment'
}

export const sumSelectedAssets = (assets, assetables, supportedCurrencies) => {
  return assetables.reduce((acc, assetable) => {
    if (assetable._destroy) {
      return acc
    }

    const asset = assets.find(asset => asset.id === assetable.asset_id)

    const exchange_rate = get(supportedCurrencies, asset.currency, 1)
    const gross_value_in_zar = convertAssetCurrencyToZar(asset.gross_value, exchange_rate)

    if (asset.asset_type == "investment_property") {
      return acc + gross_value_in_zar - R(asset.liability).value
    }

    return acc + gross_value_in_zar
  }, 0)
}

export const sumSelectedAssetsContributions = (assets, assetables, supportedCurrencies) => {
  return assetables.reduce((acc, assetable) => {
    if (assetable._destroy) {
      return acc
    }

    const asset = assets.find(asset => asset.id === assetable.asset_id)

    let monthly_contribution = asset.monthly_contribution
    let exchange_rate = get(supportedCurrencies, asset.currency, 1)
    let monthly_contribution_in_zar = convertAssetCurrencyToZar(monthly_contribution, exchange_rate)
    return acc + monthly_contribution_in_zar

  }, 0)
}

export const sumSelectedLiabilities = (liabilities, liabilitiables, assets, assetables) => {
  return liabilitiables.reduce((acc, liabilitiable) => {
    if (liabilitiable._destroy) {
      return acc
    }

    const liability = liabilities.find(liability => liability.id === liabilitiable.liability_id)

    return acc + liability.value

  }, 0) + sumSelectedInvestmentPropertyLiabilities(assets, assetables)
}

export const sumSelectedRiskProducts = (riskProducts, riskProductables) => {
  return riskProductables.reduce((acc, riskProductable) => {
    if (riskProductable._destroy) {
      return acc
    }

    const riskProduct = riskProducts.find(riskProduct => riskProduct.id === riskProductable.risk_product_id)

    return acc + R(riskProduct.value).value

  }, 0)
}

export const sumSelectedInvestmentPropertyLiabilities = (assets, assetables) => {
  return assetables.reduce((acc, assetable) => {
    if (assetable._destroy) {
      return acc
    }

    const asset = assets.find(asset => asset.id === assetable.asset_id)

    // investment_property
    if (asset.asset_type == "investment_property") {
      return acc + R(asset.liability).value
    }

    return acc
  }, 0)
}

// Life cover specific
export const totalRequirementRange = (lifeCoverAssessment) => {
  const totalRequirementObject = get(lifeCoverAssessment, 'total_requirement', { best: 0 })
  const { best, worst, risk_profile } = totalRequirementObject

  return {
    range: `${R(best).format() + (worst ? (' to ' + R(worst).format()) : '')}`,
    riskProfile: `${R(risk_profile).format()}`
  }
}
